import { Checkbox, Chip, Divider, FormControlLabel, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { BtnEdit, BtnAdd, BtnCancel, BtnEditTable } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import InputNumberItem from 'components/Input/InputNumber';
import { TextAreaItem } from 'components/Input/TextArea';
import { TextBoxItem } from 'components/Input/TextBox';
import UploadFileItem from 'components/Input/UploadFile';
import moment from 'moment';
import React, { useMemo, useState } from 'react'
import { FormProvider } from 'react-hook-form';
import CustomTablePagination from '../Ticket/components/CustomTablePagination';
import RenderCellFile from '../Ticket/components/RenderCellFile';
import { numberFormatterLocale, renderCellFileCustomTable } from '../Ticket/fnTickit';
import { Extension, FnDialog, I18n } from 'utilities/utilities';
import { SelectItem } from 'components/Input/Select/SelectItem';
import _ from "lodash";
import { I18NextNs } from 'enum/enum';

export const TableIncomeActualAdd = (props) => {

    const {
        formAdd,
        form,
        isView,
        onClearFile,
        lstIncomeActual,
        setLstIncomeActual,
        optionIncomeType
    } = props;

    const DialogFn = FnDialog();


    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [selected, setSelected] = useState<readonly number[]>([]);
    const [arrAttachment, setArrAttachment] = useState([])
    const [idEdit, setIdEdit] = useState(0)
    const [isOpenFile, setIsOpenFile] = useState(false)
    const [arrFile, setArrFile] = useState([])
    const [isExcludeIncome, setIsExcludeIncome] = useState(false)

    const isSelected = (id: number) => selected.indexOf(id) !== -1;

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelected = lstIncomeActual.map((n) => n.nID);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (id: number) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected: readonly number[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleAdd = () => {
        let lstDataNew = [];
        let deepCopy = _.cloneDeep(lstIncomeActual);
        let sFileLink = null;
        let sFileName = null;

        if (arrAttachment.length > 0) {
            let objFile = arrAttachment[0];
            sFileLink = objFile.sCropFileLink ?? ""
            sFileName = objFile.sFileName ?? ""
        }

        let nIncometypeID = formAdd.getValues("nIncometypeID");
        let sTypeIncome = "";
        let indTypeIncome = optionIncomeType.findIndex(f => f.value === nIncometypeID);

        if (indTypeIncome !== -1) {
            sTypeIncome = optionIncomeType[indTypeIncome].label;
        }
        if (idEdit !== 0) {
            //update Data
            let indEdit = deepCopy.findIndex(f => f.nID === idEdit);
            deepCopy[indEdit].nIncomeTypeID = parseInt(nIncometypeID);
            deepCopy[indEdit].sIncomeType = sTypeIncome;
            deepCopy[indEdit].isExcludeIncome = isExcludeIncome;
            deepCopy[indEdit].sIncomeItem = formAdd.getValues("sIncomeItem");
            deepCopy[indEdit].dReceive = formAdd.getValues("dReceive").valueOf();
            deepCopy[indEdit].nTotal = formAdd.getValues("nTotal");
            deepCopy[indEdit].sDescription = formAdd.getValues("sDescription");
            deepCopy[indEdit].lstFile = arrAttachment;
            deepCopy[indEdit].sFileLink = sFileLink;
            deepCopy[indEdit].sFileName = sFileName;
            lstDataNew = deepCopy;
        }
        else {
            let nIdMax = deepCopy.length > 0 ? Math.max(...deepCopy.map(itm => { return parseInt(itm.nID) })) + 1 : 1;
            let nOrderMax = deepCopy.length > 0 ? Math.max(...deepCopy.map(itm => { return parseInt(itm.nOrder) })) + 1 : 1;

            let objNew = [{
                nID: nIdMax,
                nOrder: nOrderMax,
                isNew: true,
                isDelete: true,
                nIncomeTypeID: parseInt(nIncometypeID),
                sIncomeType: sTypeIncome,
                isExcludeIncome: isExcludeIncome,
                sIncomeItem: formAdd.getValues("sIncomeItem"),
                dReceive: formAdd.getValues("dReceive").valueOf(),
                nTotal: formAdd.getValues("nTotal"),
                sDescription: formAdd.getValues("sDescription"),
                lstFile: arrAttachment,
                sFileLink: sFileLink,
                sFileName: sFileName,
            }];
            lstDataNew = [...deepCopy, ...objNew];
        }
        setIsExcludeIncome(false)
        setLstIncomeActual([...lstDataNew])
        handleClearInput();
    }

    const handleEdit = (row) => {
        setArrAttachment(row.lstFile)
        setIdEdit(row.nID)
        setIsExcludeIncome(row.isExcludeIncome)
        formAdd.reset({
            nIncometypeID: row.nIncomeTypeID,
            sIncomeItem: row.sIncomeItem,
            dReceive: moment(row.dReceive),
            nTotal: row.nTotal,
            sDescription: row.sDescription,
        })
    }

    const handleClearInput = () => {
        setIdEdit(0)
        setArrAttachment([])
        setIsExcludeIncome(false)
        onClearFile.current(null);
        formAdd.clearErrors()
        formAdd.reset({
            nIncometypeID: null,
            sIncomeItem: null,
            dReceive: null,
            nTotal: null,
            sDescription: null,
        })
    }

    const handleDelete = () => {
        if (idEdit !== 0) {
            DialogFn.Warning("ไม่สามารถดำเนินการได้ เนื่องจากมีรายการกำลังดำเนินการแก้ไข")
            return;
        }
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.CloseSubmit();
            let lstNotDelete = lstIncomeActual.filter(item => !selected.includes(item.nID));
            setLstIncomeActual([...lstNotDelete])
            setSelected([])
        });
    }


    const handleClickFile = (row) => {
        setArrFile([{ sFileLink: row.sFileLink, sFileName: row.sFileName }])
        setIsOpenFile(true)
    };

    const dDateSelect = useMemo(() => {
        let maxDate = moment();
        if (form.getValues("dDate")) {
            maxDate = moment(moment(form.getValues("dDate")).format("YYYY-MM-") + moment(form.getValues("dDate")).daysInMonth());

        }
        return maxDate
    }, [form])



    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Divider textAlign="left"><Chip className='incomeplan-chip font-weight-500' label={"รายการรายรับ"} /></Divider>
                </Grid>
                {isView ? null : <Grid item xs={12}>
                    <FormProvider {...formAdd}>
                        <Grid container spacing={2} alignItems={"flex-start"}>
                            <Grid item xs={12} sm={6} md={4}>
                                <SelectItem
                                    id={`nIncometypeID`}
                                    name={`nIncometypeID`}
                                    label={"ประเภทรายรับ"}
                                    required={true}
                                    options={optionIncomeType}
                                    disabled={false}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextBoxItem
                                    name={"sIncomeItem"}
                                    id={"sIncomeItem"}
                                    label={"ชื่อรายการ"}
                                    maxLength={250}
                                    type={"text"}
                                    required={true}
                                    IsShrink={false}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <DatePickerItem
                                    name={"dReceive"}
                                    id={"dReceive"}
                                    label={`วันที่ได้รับเงิน`}
                                    fullWidth={true}
                                    required={true}
                                    maxDate={dDateSelect}
                                    defaultCalendarMonth={dDateSelect}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <InputNumberItem
                                    id={`nTotal`}
                                    name={`nTotal`}
                                    label="จำนวนเงิน (บาท)"
                                    required={true}
                                    IsCanMinus={false}
                                    min={0}
                                    maxDigits={18}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <FormControlLabel
                                    control={<Checkbox />}
                                    label="ไม่คิดเป็นรายได้"
                                    labelPlacement="end"
                                    checked={isExcludeIncome}
                                    sx={{
                                        ".MuiFormControlLabel-label": {
                                            marginTop: '5px',
                                            color: "red"
                                        }
                                    }}
                                    onChange={() => {
                                        setIsExcludeIncome(!isExcludeIncome)
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextAreaItem
                                    id='sDescription'
                                    name='sDescription'
                                    required={false}
                                    label={"คำอธิบายเพิ่มเติม"}
                                    maxLength={500}
                                    placeholder={"คำอธิบายเพิ่มเติม"}
                                    row={3}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <UploadFileItem
                                    id="fileAttach"
                                    name={"fileAttach"}
                                    key={"fileAttach"}
                                    label="ใบเสร็จรับเงิน"
                                    arrFile={arrAttachment}
                                    setarrFile={setArrAttachment}
                                    IsFolder={false}
                                    IsMultiple={false}
                                    Extension={Extension.FileTicket}
                                    nLimitFile={30}
                                    sLimitFile={"MB"}
                                    onClearFile={onClearFile}
                                    modeDisplay={"list"}
                                    sFolderTemp={"FundIncome"}
                                    sPositionText={"right"}
                                    required={false}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={2} justifyContent={"center"}>
                                    <Grid item>
                                        {
                                            idEdit !== 0 ?
                                                <BtnEdit id="btnedit-add" onClick={formAdd.handleSubmit(handleAdd)} />
                                                :
                                                <BtnAdd id="btnAdd-add" txt="เพิ่มรายการรับเงิน" onClick={formAdd.handleSubmit(handleAdd)} />
                                        }
                                    </Grid>
                                    <Grid item>
                                        <BtnCancel id="btncancel-add" onClick={handleClearInput} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </Grid>}
                <Grid item xs={12}>
                    <TableContainer id="table-receive" component={Paper}>
                        <Table sx={{ minWidth: 800 }}>
                            <TableHead>
                                <TableRow>
                                    {isView ? null : <TableCell
                                        className="td-center"
                                        padding="checkbox"
                                        style={{ minWidth: "55px", width: "55px" }}
                                    >
                                        <Checkbox
                                            color="primary"
                                            indeterminate={selected.length > 0 && selected.length < lstIncomeActual.length}
                                            checked={lstIncomeActual.length > 0 && selected.length === lstIncomeActual.length}
                                            disabled={isView}
                                            onChange={handleSelectAllClick}
                                            inputProps={{
                                                "aria-label": "select all",
                                            }}
                                        />
                                    </TableCell>}
                                    {isView ? null : <TableCell
                                        align="center"
                                        style={{ minWidth: "55px", width: "55px" }}
                                    ></TableCell>}
                                    <TableCell
                                        align="center"
                                        style={{ minWidth: "100px", width: "100px" }}
                                    >
                                        วันที่รับเงิน
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ minWidth: "140px", width: "140px" }}
                                    >
                                        ประเภทรายรับ
                                    </TableCell>
                                    <TableCell align="center">
                                        ชื่อรายการ
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ minWidth: "140px", width: "140px" }}
                                    >
                                        จำนวนเงิน (บาท)
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ minWidth: "95px", width: "95px" }}
                                    >
                                        ใบเสร็จรับเงิน
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            {lstIncomeActual.length > 0 ? (
                                <TableBody>
                                    {lstIncomeActual
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, index) => {
                                            let nNo = page * rowsPerPage + (index + 1);
                                            const isItemSelected = isSelected(row.nID);

                                            return (
                                                <TableRow key={nNo}>
                                                    {isView ? null : <TableCell padding="checkbox">
                                                        <Checkbox
                                                            color="primary"
                                                            checked={isItemSelected}
                                                            disabled={isView}
                                                            onClick={() => handleClick(row.nID)}
                                                            inputProps={{
                                                                "aria-labelledby": `aria-${nNo}`,
                                                            }}
                                                        />
                                                    </TableCell>}
                                                    {isView ? null : <TableCell align="center">
                                                        <BtnEditTable
                                                            id={`btnedit-${nNo}`}
                                                            onClick={() => handleEdit(row)}
                                                            IsCircleWithOutText
                                                        />
                                                    </TableCell>}
                                                    <TableCell align="center">{moment(row.dReceive).add(543, "years").format("DD/MM/YYYY")} </TableCell>
                                                    <TableCell align="left">{row.sIncomeType}</TableCell>
                                                    <TableCell align="left">{row.sIncomeItem}</TableCell>
                                                    <TableCell align="right">{numberFormatterLocale(row.nTotal, 2)}</TableCell>
                                                    <TableCell align="center">
                                                        {row.sFileLink && renderCellFileCustomTable(nNo, row, handleClickFile)}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            ) : (
                                <TableRow key={"r-no-data"}>
                                    <TableCell align="center" colSpan={isView ? 5 : 7}>
                                        ไม่พบข้อมูล
                                    </TableCell>
                                </TableRow>
                            )}
                        </Table>
                    </TableContainer>
                    <CustomTablePagination
                        dataTable={lstIncomeActual}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        page={page}
                        setPage={setPage}
                        colSpan={isView ? 5 : 7}
                        onDelete={handleDelete}
                        isShowDelete={selected.length > 0}
                        OptionRowsPerPage={[5, 10, 25, 50, 100]}
                    />
                </Grid>
            </Grid>
            <RenderCellFile
                isOpen={isOpenFile}
                setIsOpen={setIsOpenFile}
                arrFile={arrFile}
            />
        </>
    )
}